// BlackoutCurtain — heldekkende overlegg som skjuler innhold når
// `useScreenshotDeter` fanger et mistenkelig event (visibilitychange,
// blur, PrintScreen). Vises innenfor den beskyttede seksjonen —
// stopper ikke DOM-inspeksjon, men blokkerer skjermbilder av visuell
// innhold i det korte vinduet mens screenshot-verktøy er aktivt.
import React from "react";
import { Eye, EyeOff } from "lucide-react";

export default function BlackoutCurtain({ active, message = "Beskyttet innhold — vises kun med fokus", testId = "blackout-curtain" }) {
  if (!active) return null;
  return (
    <div
      className="absolute inset-0 z-40 flex items-center justify-center bg-black/95 backdrop-blur-lg transition-opacity"
      data-testid={testId}
      aria-live="polite"
    >
      <div className="text-center px-6">
        <EyeOff className="w-10 h-10 mx-auto mb-3 text-[var(--magenta)]" />
        <div className="font-fraunces italic text-lg text-[var(--cream)] mb-1">
          Beskyttet innhold
        </div>
        <div className="font-manrope text-xs text-[var(--cream-soft)] max-w-xs">
          {message}
        </div>
      </div>
    </div>
  );
}
